import {
  CircularProgress,
  Box,
  Drawer,
  Alert,
  Snackbar,
  useMediaQuery,
} from "@mui/material";

import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import React, { useEffect, useState, useMemo, useRef } from "react";
import {
  clearNewTempPermitData,
  getAllPermitPackages,
  getSavedProjects,
} from "../../../store/actions/dataActions";
import OpenDocuments from "../../noc/OpenDocuments";
import { useTour } from "@reactour/tour";
import { clearForwardNotification } from "../../../store/actions/notificationsActions";
import PromoModal from "../../popover/promoPopover/PromoModal";
import DemoPopPaymentModal from "../../popover/promoPopover/DemoPopPaymentModal";
import AddPaymentCardModal from "../../modals/AddPaymentCardModal";
import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";
import {
  clearMyPermitState,
  setPermitLoadings,
  setModalsState,
  setPage,
  setRightValue,
  setRowCount,
  setSelectedRow,
  setDocumentImage,
  setCreatingDocTitle,
  setLeftValue,
  setSelectedPermitType,
  setAttachingNewPermit,
} from "../../../store/actions/uiActions/myPermitsActions";
import DesignProAddInfoModal from "../../modals/DesignProAddInfoModal";

import { formikRef } from "../../../store/formikStore/formikStore";
import RemoveDesignProModal from "../../modals/RemoveDesignProModal";
import RemoveProjectContactModal from "../../modals/RemoveProjectContactModal";
import RemoveFeeSimpleModal from "../../modals/RemoveFeeSimpleModal";
import RemoveBondingModal from "../../modals/RemoveBondingModal";
import RemoveMortgageModal from "../../modals/RemoveMortgageModal";
import RemoveTermiteModal from "../../modals/RemoveTermiteModal";
import RemovePrivateProviderModal from "../../modals/RemovePrivateProviderModal";
import AddingNewProjectModal from "../../modals/financialBPModals/AddingNewProjectModal";
import AddingNewFeeSimpleModal from "../../modals/financialBPModals/AddingNewFeeSimpleModal";
import AddingNewBondingModal from "../../modals/financialBPModals/AddingNewBondingModal";
import AddingNewMortgageModal from "../../modals/financialBPModals/AddingNewMortgageModal";
import AddingNewTermiteModal from "../../modals/financialBPModals/AddingNewTermiteModal";
import AddingNewPrivateProviderModal from "../../modals/financialBPModals/AddingNewPrivateProviderModal";
import SubuserPermitGrid from "../../permitComponents/SubuserPermitGrid";

const SubuserPermits = () => {
  const currentSession = useSelector((state) => state.sessions.currentSession);
  const currentUser = useSelector((state) => state[currentSession].user);
  const permitPackages = useSelector((state) => state.nocData?.permitPackages);
  const newTempPermitData = useSelector(
    (state) => state.nocData?.newTempPermitData,
  );

  const attachingNewPermit = useSelector(
    (state) => state.myPermitsComponent.attachingNewPermit,
  );

  const { selectedPermitType } = useSelector(
    (state) => state.myPermitsComponent,
  );

  const mobileSize = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  const memoizedDrawerContent = useMemo(() => <OpenDocuments />, []);

  const {
    addingNewDesignPro,
    addingNewProject,
    addingNewFeeSimple,
    addingNewBonding,
    addingNewMortgage,
    addingNewTermite,
    addingNewPrivateProvider,
  } = useSelector((state) => state.buildingState);
  const notifications = useSelector((state) => state.notifications);

  const { dataLoading } = useSelector(
    (state) => state.myPermitsComponent.permits.loadings,
  );

  const {
    permitDrawerOpen,
    promoModalOpen,
    paymentModalOpen,
    addPaymentModalOpen,
  } = useSelector((state) => state.myPermitsComponent.permits.modalStates);

  const {
    projectConfirmModalOpen,
    feeSimpleConfirmModalOpen,
    bondingConfirmModalOpen,
    mortgageConfirmModalOpen,
    termiteConfirmModalOpen,
    privateProviderConfirmModalOpen,
    addDesignProConfirmOpen,
  } = useSelector((state) => state.modalControlState.buildingPermit);

  const stripe = useStripe();
  const elements = useElements();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const formik = formikRef.current;

  const [loading, setLoading] = useState(true);
  const [newPermitOpened, setNewPermitOpened] = useState(false);
  const [docNotaryTypeValue, setDocNotaryTypeValue] = useState(0);

  const [snackOpen, setSnackOpen] = useState(false);
  const [gridKey, setGridKey] = useState(0);
  const [selectionModel, setSelectionModel] = useState([]);
  const { isOpen, currentStep, setCurrentStep } = useTour();

  const hasFetchedOnceRef = useRef(false);

  useEffect(() => {
    return () => {
      dispatch(clearMyPermitState());
    };
  }, [dispatch]);

  useEffect(() => {
    if (isOpen && currentSession === "userSession") {
      if (currentStep === 16) {
        dispatch(setRightValue(1));
      } else if (currentStep === 17) {
        dispatch(setRightValue(2));
      } else if (currentStep === 18) {
        dispatch(setRightValue(3));
      } else if (currentStep === 19) {
        dispatch(setRightValue(4));
      } else if (currentStep === 20) {
        dispatch(setRightValue(5));
      }
    } else if (isOpen && currentSession === "subUserSession") {
      if (currentStep === 13) {
        dispatch(setRightValue(0));
      } else if (currentStep === 14) {
        dispatch(setRightValue(1));
      } else if (currentStep === 15) {
        dispatch(setRightValue(2));
      } else if (currentStep === 16) {
        dispatch(setRightValue(3));
      } else if (currentStep === 17) {
        dispatch(setRightValue(4));
      } else if (currentStep === 18) {
        dispatch(setRightValue(5));
      }
    }
  }, [currentStep, isOpen, currentSession, dispatch]);

  const snackHandleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackOpen(false);
  };

  const handlePermitDrawerClose = () => {
    try {
      const active = document?.activeElement;
      if (active && active instanceof HTMLElement) {
        active.blur();
      }
    } catch {}
    dispatch(setModalsState({ permitDrawerOpen: false }));
  };

  // Ensure no element inside the Drawer retains focus after it closes
  useEffect(() => {
    if (!permitDrawerOpen) {
      try {
        const active = document?.activeElement;
        if (active && active instanceof HTMLElement) {
          active.blur();
        }
      } catch {}
    }
  }, [permitDrawerOpen]);

  useEffect(() => {
    const fetchSpecial = async () => {
      if (notifications?.forwardNotifications?.packageId !== null) {
        await dispatch(setPermitLoadings({ dataLoading: true }));

        await dispatch(getSavedProjects());
        const result = await dispatch(
          getAllPermitPackages({
            forwardNotification: notifications?.forwardNotifications,
            filters: null,
          }),
        );

        dispatch(clearForwardNotification());

        const selectedPackageId =
          notifications?.forwardNotifications?.packageId;

        const foundRow = result?.data?.documents?.find(
          (doc) => doc.id === selectedPackageId,
        );

        dispatch(setRowCount(result?.data?.total_count || 0));
        dispatch(setPage(result?.data?.current_page || 0));

        if (foundRow) {
          setSelectionModel([foundRow?.id]);
          setGridKey((prevKey) => prevKey + 1);
          await dispatch(setSelectedRow(foundRow)); // Set the matched row
        }

        setLoading(false);
        await dispatch(setCreatingDocTitle("Notice of Commencement"));
        await dispatch(setPermitLoadings({ dataLoading: false }));
      }
    };
    fetchSpecial();
  }, [notifications?.forwardNotifications, dispatch]);

  useEffect(() => {
    if (newTempPermitData && !newPermitOpened && !attachingNewPermit?.started) {
      const newRow = newTempPermitData;

      if (!isOpen) {
        setNewPermitOpened(true);
        dispatch(setSelectedRow(newRow));

        // If user just created an additional permit, selectedPermitType will already be set
        // Ensure preview shows the first doc from that permit type when available
        // if (
        //   selectedPermitTypeFromStore &&
        //   newRow?.additional_permits &&
        //   newRow?.additional_permits[selectedPermitTypeFromStore]
        // ) {
        //   const addItem = Array.isArray(
        //     newRow.additional_permits[selectedPermitTypeFromStore]
        //   )
        //     ? newRow.additional_permits[selectedPermitTypeFromStore][0]
        //     : newRow.additional_permits[selectedPermitTypeFromStore];
        //   const firstDoc = addItem?.selected_documents?.[0];
        //   const docName = firstDoc?.name;
        //   if (docName) {
        //     dispatch(setCreatingDocTitle(firstDoc?.label || docName));
        //     const docImg = addItem?.documents?.[docName]?.signed?.length
        //       ? addItem?.documents?.[docName]?.signed
        //       : firstDoc?.img;
        //     dispatch(setDocumentImage(docImg));
        //   }
        // } else {
        dispatch(setCreatingDocTitle("Notice of Commencement"));
        dispatch(setDocumentImage(newRow?.selected_documents?.[0]?.img));
        // }

        // Open the modal
        dispatch(setModalsState({ permitDrawerOpen: true }));
      }

      dispatch(clearNewTempPermitData());
    }

    const fetchData = async () => {
      if (hasFetchedOnceRef.current) return;
      hasFetchedOnceRef.current = true;

      await dispatch(setPermitLoadings({ dataLoading: true }));
      await dispatch(getSavedProjects());

      // if (attachingNewPermit?.started) {
      //   result = await dispatch(
      //     getPermitPackages({
      //       newPage: attachingNewPermit?.prevPermitGrid?.page,
      //     })
      //   );
      // } else {
      const result = await dispatch(
        getAllPermitPackages({
          filters: null,
          sortDirection: "desc",
          sortField: "permit_package_added_at",
        }),
      );
      // }

      dispatch(setRowCount(result?.data || 0));
      setLoading(false);
      await dispatch(setCreatingDocTitle("Notice of Commencement"));
      await dispatch(setPermitLoadings({ dataLoading: false }));
    };

    if (
      notifications?.forwardNotifications?.packageId === null &&
      !attachingNewPermit?.started
    ) {
      fetchData();
    } else if (
      attachingNewPermit?.started &&
      newTempPermitData &&
      !newPermitOpened
    ) {
      const handleAttachingNewPermit = async () => {
        if (hasFetchedOnceRef.current) return;
        hasFetchedOnceRef.current = true;

        const newPage = attachingNewPermit?.prevPermitGrid?.page;

        dispatch(setPermitLoadings({ dataLoading: true }));
        await dispatch(getSavedProjects());
        dispatch(setPage(newPage));

        const result = await dispatch(
          getAllPermitPackages({
            newPage: newPage,
            filters: null,
          }),
        );
        dispatch(setRowCount(result?.data || 0));

        setNewPermitOpened(true);
        const newRow = newTempPermitData;

        // Determine newly added permit type by diffing against the previous permit types
        const previousTypes = new Set(attachingNewPermit?.addedPermits || []);
        const additionalKeys = Object.keys(newRow?.additional_permits || {});
        const newlyAddedType = additionalKeys.find(
          (k) => !previousTypes.has(k),
        );

        const newPermitType =
          newlyAddedType || selectedPermitType || newRow?.permit_type;

        // Resolve the current permit object based on the computed permit type
        const selectedAdditional = newRow?.additional_permits?.[newPermitType];
        const currentPermit =
          newPermitType === newRow?.permit_type
            ? newRow
            : Array.isArray(selectedAdditional)
              ? selectedAdditional?.[0]
              : selectedAdditional;

        // Ensure selectedPermitType is set first so dependent components pick it up
        dispatch(setSelectedPermitType(newPermitType));
        dispatch(setSelectedRow(newRow));
        dispatch(setLeftValue(0));
        dispatch(
          setCreatingDocTitle(currentPermit?.selected_documents?.[0]?.label),
        );
        dispatch(setDocumentImage(currentPermit?.selected_documents?.[0]?.img));

        dispatch(setPermitLoadings({ dataLoading: false }));
        setLoading(false);

        dispatch(clearNewTempPermitData());
        dispatch(
          setAttachingNewPermit({
            started: false,
            taskId: "",
            form: {},
            county: "",
            city: "",
            addedPermits: [],
            additionalPermits: {},
            usedContractors: [],
            packageSnapshot: null,
            prevPermitGrid: {
              page: 0,
              pageSize: 5,
              rowCount: 0,
            },
          }),
        );
        // Open drawer after state updates settle to avoid flicker
        setTimeout(() => {
          dispatch(setModalsState({ permitDrawerOpen: true }));
        }, 0);
      };

      handleAttachingNewPermit();
    }
  }, [
    dispatch,
    isOpen,
    newPermitOpened,
    newTempPermitData,
    notifications?.forwardNotifications?.packageId,
    selectedPermitType,
    attachingNewPermit,
  ]);

  useEffect(() => {
    const correctStep = currentSession === "subUserSession" ? 20 : 30;
    const nextStep = currentSession === "subUserSession" ? 10 : 12;
    if (
      isOpen &&
      currentStep === correctStep &&
      permitPackages.length > 0 &&
      !loading &&
      !dataLoading
    ) {
      setTimeout(() => {
        setCurrentStep((s) => nextStep);
      }, 200);
    }
  }, [
    permitPackages,
    currentStep,
    isOpen,
    loading,
    currentSession,
    setCurrentStep,
    dataLoading,
  ]);

  useEffect(() => {
    const correctStep = currentSession === "userSession" ? 21 : 21;

    if (
      isOpen &&
      currentStep === correctStep &&
      permitPackages.length > 0 &&
      !loading &&
      !dataLoading
    ) {
      dispatch(setSelectedRow(permitPackages[0]));
      setTimeout(() => {
        setRightValue(5);
      }, 200);
    }
  }, [
    permitPackages,
    currentStep,
    isOpen,
    loading,
    currentSession,
    dispatch,
    dataLoading,
  ]);

  useEffect(() => {
    if (currentUser) {
      if (currentUser?.user?.expired === true) {
        navigate("/subscription");
      }
    }
  }, [currentUser, navigate]);

  const memoizedGridSection = useMemo(
    () => (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          px: mobileSize ? 0 : "1.5rem",
          py: mobileSize ? 0 : "1.5rem",
        }}
      >
        <Box sx={{ maxWidth: "1920px", width: "100%", height: "100%" }}>
          <Box
            sx={{
              borderRadius: mobileSize ? 0 : "1.5rem",
              boxShadow: "2px 3px 5px #d3d3d3",
              height: {
                xs: "100%",
                xl: "100%",
              },
              backgroundColor: "#fff",
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                height: "100%",
                minHeight: 0,
              }}
            >
              <SubuserPermitGrid
                gridKey={gridKey}
                selectionModel={selectionModel}
                setSelectionModel={setSelectionModel}
                setDocNotaryTypeValue={setDocNotaryTypeValue}
                docNotaryTypeValue={docNotaryTypeValue}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    ),
    [gridKey, selectionModel, docNotaryTypeValue, mobileSize],
  );

  return (
    <>
      {loading ? (
        <>
          <Box
            sx={{
              display: "flex",
              width: "100%",
              height: "100vh",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <CircularProgress color="warning" size="10rem" />
          </Box>
        </>
      ) : (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            p: mobileSize ? "0px" : "1.5rem",
          }}
        >
          <Box sx={{ maxWidth: "1920px", width: "100%", height: "100%" }}>
            <Box
              sx={{
                borderRadius: mobileSize ? 0 : "1.5rem",
                boxShadow: "2px 3px 5px #d3d3d3",
                minHeight: "100%",
                ...(mobileSize
                  ? {
                      height: "100%",
                      maxHeight: "100%",
                    }
                  : null),
                backgroundColor: "#fff",
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
                // p: 2,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  minHeight: 0,
                  height: "100%",
                }}
              >
                {memoizedGridSection}
              </Box>
            </Box>
          </Box>
        </Box>
      )}
      <Drawer
        ModalProps={{
          keepMounted: false,
          disableEnforceFocus: true,
          disableAutoFocus: true,
          disableRestoreFocus: true,
        }}
        slotProps={{
          root: {
            sx: {
              pointerEvents: permitDrawerOpen ? "auto" : "none",
            },
          },
          backdrop: {
            sx: {
              pointerEvents: permitDrawerOpen ? "auto" : "none",
            },
          },
          paper: {
            sx: {
              width: "100vw",
              overflow: "hidden",
            },
          },
        }}
        anchor="right"
        sx={{ pointerEvents: permitDrawerOpen ? "auto" : "none" }}
        open={permitDrawerOpen}
        onClose={handlePermitDrawerClose}
      >
        {memoizedDrawerContent}
      </Drawer>

      {/* Duval Building Permit Modals */}
      {formik?.values && addingNewDesignPro && <DesignProAddInfoModal />}
      {formik?.values && addingNewProject && <AddingNewProjectModal />}
      {formik?.values && addingNewFeeSimple && <AddingNewFeeSimpleModal />}
      {formik?.values && addingNewBonding && <AddingNewBondingModal />}
      {formik?.values && addingNewMortgage && <AddingNewMortgageModal />}
      {formik?.values && addingNewTermite && <AddingNewTermiteModal />}
      {formik?.values && addingNewPrivateProvider && (
        <AddingNewPrivateProviderModal />
      )}

      {formik?.values && addDesignProConfirmOpen && <RemoveDesignProModal />}
      {formik?.values && projectConfirmModalOpen && (
        <RemoveProjectContactModal />
      )}
      {formik?.values && feeSimpleConfirmModalOpen && <RemoveFeeSimpleModal />}
      {formik?.values && bondingConfirmModalOpen && <RemoveBondingModal />}
      {formik?.values && mortgageConfirmModalOpen && <RemoveMortgageModal />}
      {formik?.values && termiteConfirmModalOpen && <RemoveTermiteModal />}
      {formik?.values && privateProviderConfirmModalOpen && (
        <RemovePrivateProviderModal />
      )}

      {/* ############################# */}

      {promoModalOpen && <PromoModal />}
      {paymentModalOpen && <DemoPopPaymentModal />}
      <Snackbar
        open={snackOpen}
        autoHideDuration={6000}
        onClose={snackHandleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={snackHandleClose}
          severity="success"
          sx={{ width: "100%" }}
        >
          Payment Successful. Thank you
        </Alert>
      </Snackbar>
      {addPaymentModalOpen && (
        <AddPaymentCardModal
          stripe={stripe}
          elements={elements}
          CardElement={CardElement}
        />
      )}
    </>
  );
};

export default React.memo(SubuserPermits);
